import {ProgramPaths} from "@/enum/ProgramPaths";

export type RenewalTier = 'button' | 'modal' | 'countdown' | null;

export type RenewalProductKey = 'icrapro' | 'eicrapro';

// Route path'inden yenileme ürün anahtarı. Bileşenler bunu this.$route.path ile
// çağırmalı (reaktif); window.location.pathname Vuex getter'ında reaktif DEĞİLDİR
// ve ürün geçişinde bayat teklif gösterir.
export function renewalProductKeyForPath(path: string): RenewalProductKey {
    return path.startsWith(ProgramPaths.eicrapro) ? 'eicrapro' : 'icrapro';
}

export interface RenewalOffer {
    eligible: boolean;
    tier: RenewalTier;
    days_left: number | null;
    end_date: string | null;
    package_name: string | null;
}

// GET /api/v1/renewal-offer yanıt şekli. Uygulama artık bu ucu ÇAĞIRMIYOR
// (veri /ben içindeki `lisans_durum` ile geliyor); uç geriye dönük uyumluluk
// için API'de durduğundan sözleşme burada korunur.
export interface RenewalOffers {
    icrapro: RenewalOffer;
    eicrapro: RenewalOffer;
}

// /api/v1/ben yanıtındaki ham lisans özeti (ürün başına). days_left/tier gibi
// zamana bağlı alanlar BİLEREK yoktur: özet sessionStorage'da sekme kapanana
// kadar yaşadığı için o hesaplar aşağıda, her okumada yeniden yapılır.
export interface LisansDurumUrun {
    demo: boolean;
    end_date: string | null;
    package_name: string | null;
}

export interface LisansDurum {
    icrapro: LisansDurumUrun;
    eicrapro: LisansDurumUrun;
}

// Kademe sınırları (kalan gün): 21-30 buton, 8-20 modal, 0-7 geri sayım.
export function tierForDaysLeft(daysLeft: number): RenewalTier {
    if (daysLeft >= 21 && daysLeft <= 30) return 'button';
    if (daysLeft >= 8 && daysLeft <= 20) return 'modal';
    if (daysLeft >= 0 && daysLeft <= 7) return 'countdown';
    return null;
}

// Bitiş tarihine kalan TAM gün (negatif olabilir). Backend'deki
// Carbon::today()->diffInDays($end->startOfDay(), false) ile aynı anlam:
// iki tarafta da gün başlangıcına yuvarlanır, saat farkı sayılmaz.
export function daysLeftUntil(endDate: string | Date, now: Date = new Date()): number {
    const end = new Date(endDate);
    const endGun = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());
    const bugun = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    return Math.round((endGun - bugun) / 86400000);
}

// Ham özetten yenileme teklifi. Demo lisanslar teklife girmez — backend
// RenewalOfferService::getOffer de aynı elemeyi yapıyordu.
export function offerFromLisansDurum(urun: LisansDurumUrun | null | undefined, now: Date = new Date()): RenewalOffer | null {
    if (!urun || !urun.end_date) return null;

    const daysLeft = daysLeftUntil(urun.end_date, now);
    const tier = urun.demo ? null : tierForDaysLeft(daysLeft);

    return {
        eligible: tier !== null,
        tier,
        days_left: daysLeft,
        end_date: urun.end_date,
        package_name: urun.package_name,
    };
}

// Demo karşılığı (demoStatusFromLisansDurum) utils/demoStatus.ts içindedir;
// o modül zaten buradan import ettiği için ters yönde bağımlılık kurulmaz.

export interface CountdownParts {
    gun: number;
    saat: number;
    dakika: number;
    saniye: number;
    /** Süre doldu mu (hedef geçmişte). */
    bitti: boolean;
}

export function countdownParts(endDate: string | Date, now: Date = new Date()): CountdownParts {
    const diffMs = Math.max(0, new Date(endDate).getTime() - now.getTime());
    const totalSeconds = Math.floor(diffMs / 1000);
    return {
        gun: Math.floor(totalSeconds / 86400),
        saat: Math.floor((totalSeconds % 86400) / 3600),
        dakika: Math.floor((totalSeconds % 3600) / 60),
        saniye: totalSeconds % 60,
        bitti: diffMs <= 0,
    };
}

/** İki haneli, sabit genişlikli (tabular) sayı: 3 -> "03". */
export function pad2(n: number): string {
    return String(n).padStart(2, '0');
}

export function formatCountdown(endDate: string | Date, now: Date = new Date()): string {
    const p = countdownParts(endDate, now);
    return `%10 indirim için kalan süre: ${p.gun} Gün ${p.saat} Saat ${p.dakika} Dakika`;
}
